import React from 'react'

import {
  B2,
  B4,
  B5,
  Icon,
  SH3,
  Stack,
  XStack,
  YStack,
  colors as zetColors,
} from '@zet/design-system'
import { useExperiments } from '@zet/experiments'
import { i18n } from '@zet/localization'
import { LeadStatus } from '@zet/utils/Constants'
import moment from 'moment'

import ZetCoins from '../../svg/assets/ZetCoinsFilled.svg'

type LeadFulFilledProps = {
  item?: object
  payoutDetails?: string
  brandName?: string
}

const LeadFulFilled = ({
  item,
  payoutDetails,
  brandName,
}: LeadFulFilledProps) => {
  const status = item?.status
  const brand = brandName
  const extraCommission = item?.extraCommission
  const coins = item?.coins
  const { data: experiments } = useExperiments()
  const isNewRecommendation = experiments?.UI_IsNewRecommendation
  const getRejectionAmount = () => {
    if (isNewRecommendation) {
      return item?.dynamicRejectionPayout || item?.rejectionPayout
    } else {
      return 25
    }
  }
  const handleText = () => {
    if (item?.commissionType === 'flat')
      return `${i18n.t('myLeads.cashFlat', {
        brandCommission: item?.brandCommission,
      })}${extraCommission ? ' + ₹' : ''}${
        extraCommission ? extraCommission : ''
      }${coins ? ' + ' : ''}${coins ? coins : ''}`
    else
      return `${i18n.t('myLeads.cashPercentage', {
        brandCommission: item?.brandCommission,
      })}${extraCommission ? ' + ' : ''}${
        extraCommission ? extraCommission : ''
      }${extraCommission ? '% ' : ''}${coins ? ' + ' : ''}${coins ? coins : ''}`
  }

  if (
    status === LeadStatus.LEAD_ADDED ||
    status === LeadStatus.ACTION_REQUIRED
  ) {
    return (
      <Stack className="border-grays-30 bg-neutral-white100 mt-2 rounded-sm border-l-4 ">
        <XStack className="py-4/2 px-3">
          <Stack className="bg-grays-30 absolute left-[30] h-4 w-1" />
          <Stack className="bg-grays-30 absolute left-3 top-3 items-center rounded-lg">
            <Icon
              type={'DoneOutlined'}
              size={20}
              color={zetColors.grays[50]}
              className="m-1.5"
            />
          </Stack>
          <Stack className="left-6 mt-2 items-center justify-center">
            <SH3 className=" text-grays-80">{i18n.t('leads.saleComplete')}</SH3>
          </Stack>
        </XStack>

        {payoutDetails ? (
          <Stack className="mb-4/2 bg-grays-20 mx-3 mt-1 items-start">
            <Stack className="px-4/2 py-1">
              {Boolean(item?.brandCommission) &&
                (i18n.locale === 'en' ? (
                  <XStack>
                    <B2 className="text-grays-80">
                      {i18n.t('leads.earnUpto')}
                    </B2>
                    <B2>
                      {handleText()}
                      {Boolean(coins) && (
                        <>
                          <Stack>
                            <ZetCoins
                              height={20}
                              width={20}
                              style={{ top: 5 }}
                            />
                          </Stack>
                          {` ${i18n.t('payoutBreakoutLoyalty.zetCoins')}`}
                        </>
                      )}
                    </B2>
                  </XStack>
                ) : (
                  <XStack>
                    <B2 className="text-grays-80">
                      {handleText()}
                      {Boolean(coins) && (
                        <>
                          <Stack>
                            <ZetCoins
                              height={20}
                              width={20}
                              style={{ top: 5 }}
                            />
                          </Stack>
                          {` ${i18n.t('payoutBreakoutLoyalty.zetCoins')}`}
                        </>
                      )}
                    </B2>
                    <B2 className="text-grays-80">
                      {i18n.t('leads.earnUpto')}
                    </B2>
                  </XStack>
                ))}
              {item?.dynamicRejectionPayout || item?.rejectionPayout ? (
                <B5 className=" text-grays-60">
                  {i18n.t('leads.earnOnRejection', {
                    amount: getRejectionAmount(),
                  })}
                </B5>
              ) : null}
            </Stack>
          </Stack>
        ) : null}
      </Stack>
    )
  } else {
    return (
      <Stack className="border-grays-30 bg-neutral-white100 mt-2 rounded-sm border-l-4">
        <XStack className="py-4/2 px-3">
          <Stack className="bg-success-8 absolute left-[30] h-4 w-1" />
          <Stack className="bg-success-8 absolute left-3 top-3 items-center rounded-lg">
            <Icon
              type={'DoneOutlined'}
              size={20}
              color={zetColors.success[100]}
              className="m-1.5"
            />
          </Stack>
          <YStack className="left-6 justify-center">
            <SH3 className=" text-grays-60 ">
              {i18n.t('leads.saleComplete')}
            </SH3>
            <B4 className="text-grays-50 w-3/4">
              {i18n.t('leads.saleCompleteDescription', {
                brand: brand,
                date: moment.utc(item?.lastUpdatedDate)?.format('DD-MMM-YYYY'),
              })}
            </B4>
            {item?.orderDate ? (
              <B4 className="text-grays-50 pt-1">
                {i18n.t('leads.orderDate', {
                  date: moment.utc(item?.orderDate)?.format('DD-MMM-YYYY'),
                })}
              </B4>
            ) : (
              <></>
            )}
          </YStack>
        </XStack>
      </Stack>
    )
  }
}

export default LeadFulFilled
